import React from 'react';

import { useMatchTime } from 'hooks';

import './matchTime.scss';

interface Props {
    matchId: string;
}

const MatchTime: React.FC<Props> = ({ matchId }) => {
    const { currentMatchPart, matchTimeToShow } = useMatchTime({
        matchId,
    });

    if (!matchTimeToShow && !currentMatchPart) return null;

    return (
        <div className="__app-MatchTime-container" styleName="container">
            {currentMatchPart && (
                <span className="__app-MatchTime-part" styleName="part">
                    {currentMatchPart}&nbsp;
                </span>
            )}

            {matchTimeToShow && (
                <span className="__app-MatchTime-time" styleName="time">
                    {matchTimeToShow}
                </span>
            )}
        </div>
    );
};

export default MatchTime;
